import { RadioAvatarCard } from 'components/Form/RadioAvatarCard/RadioAvatarCard';
import { Moment } from 'moment-timezone';
import React from 'react';
import { Staff } from 'types/Staff';

interface StaffRadioCardProps {
    staff: Staff;
    dateFormat: string;
    loading: boolean;
    selected?: boolean;
    busyForWeeks?: number;
    availableAt?: Moment;
    onSelected: () => void;
}

export const StaffRadioCard: React.FC<StaffRadioCardProps> = props => {
    const description = React.useMemo(() => {
        if (props.loading) {
            return <>&nbsp;</>;
        }

        if (props.busyForWeeks) {
            return `Busy for ${props.busyForWeeks} weeks`;
        }

        if (props.availableAt) {
            return (
                <>
                    Available: <b>{props.availableAt.format('MMM D, YYYY')}</b>
                </>
            );
        }

        return <>&nbsp;</>;
    }, [props.busyForWeeks, props.availableAt, props.loading]);

    return (
        <div>
            <RadioAvatarCard
                loading={props.loading}
                label={props.staff.name}
                description={description}
                avatar={props.staff.avatar}
                checked={props.selected}
                onChange={props.onSelected}
            />
        </div>
    );
};
